/*******************************************************************************
 * Copyright (c) 2025 Bula Technologies
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 1.0.0
 *
 *******************************************************************************/

import { Box, Grid } from "@mui/material"
import ContentCard from '../../../../../components/ui-elements/cards/ContentCard';

const DashboardPage = () => {


  return (
    <>
      <Box m={6}>
        <Grid container spacing={4}>
          {/* <Grid item xs={12} sm={3} md={3}>
            <ContentCard link="/view-boc" title="Banc Of California" subTitle="View BOC Balances & Transactions"  >
            </ContentCard>
          </Grid> */}
          <Grid item xs={12} sm={3} md={3}>
            <ContentCard link="/view-ledger" title="Ledger" subTitle="View Ledger Details"  >
            </ContentCard>
          </Grid>
          <Grid item xs={12} sm={3} md={3}>
            <ContentCard link="/view-aeropay" title="Aeropay" subTitle="View Aeropay Transactions">
            </ContentCard>
          </Grid>
          <Grid item xs={12} sm={3} md={3}>
            <ContentCard title="Gamble ID" subTitle="Gamble ID Dashboard"
              onClick={() => {
                window.open("https://portal.gidx-service.in", "_blank");
              }}
              style={{ cursor: "pointer" }}  >
            </ContentCard>
          </Grid>
          {process.env.REACT_APP_NODE_ENV_VAR !== "PROD" && <Grid item xs={12} sm={3} md={3}>
            <ContentCard link="/automated-testing" title="Automated Testing" subTitle="Testing">
            </ContentCard>
          </Grid>}
        </Grid>
      </Box>
    </>
  )
}

export default DashboardPage
